import { Injectable } from '@angular/core';
import { ComplexFormParent } from '../utils/complex-form-parent';
import { Office, RequestParameters } from '@tangilla/tg-ng-models';

@Injectable({
  providedIn: 'root'
})
export class ChangeBrokerageService extends ComplexFormParent {

  override initializeForm() {
    super.initializeForm();
  }

  override initializeOnAfterRenderPage() {

  }

  override initializeOnCurrentPageChanging() {
    this.surveyService.surveyModel.onAfterRenderPage.add((sender, options) => {
      const currentPage = sender.currentPage;
      switch (currentPage.name) {
        case 'Confirmation':
          if (this.surveyService.chargeable) {
            this.buildOrderConfirmation('change_office');
          } else {
            this.setNoChargesHtmlTable();
          }
          break;
      }
    });

  }

  override initializeOnValueChanged() {
    this.surveyService.surveyModel.onValueChanged.add((sender, options) => {
      if (options.name === 'office') {
        const officeIdSelected = sender.getValue('office');
        if (officeIdSelected) {
          this.officesApiService.getOffice(officeIdSelected).subscribe({
            next: (office: any) => {
              sender.setVariable('selected_office', office);
              sender.setVariable('office_name', office.business_name);
              sender.setVariable('dr_name', office.field_description.designated_realtor);
              this.validateMlsOfChoice(office);
              const personRelationship = this.surveyService.personRelationships.find(r => r.office_nrds_id === this.surveyService.officeId);
              const memberRecord = this.surveyService.memberRecord;
              const formAssociation = this.surveyService.surveyModel.getVariable('v-association_nrds');

              if (personRelationship && personRelationship.role_type !== 'MLO' && memberRecord.local_association_id === formAssociation) {
                this.validateBoardsInCommon(office);
              }
              this.validateCorporateStructure(office);
            },
            error: (error) => {
              this.errorsService.processError(error, 'soft')
            }
          });
        }
      }
    });
  }

  private validateBoardsInCommon(office: Office) {
    
    this.memberApiService.getMemberBoardsInCommon(this.surveyService.memberId as string, office.office_nrds_id).subscribe({
      next: (boardsInCommon: any) => {
        if (!boardsInCommon || boardsInCommon.length === 0) {
          const fname = this.surveyService.surveyModel.getValue('FirstName');
          const title = `Hi ${fname}!`;
          const error_message_membership = `The designated licensee for ${office['business_name']} (#${office.office_nrds_id}) does not have a board in common with you. <br /><br />` +
            `If this is the office you want to apply for, choose a different type of membership or contact your sponsor.<br />`;
          this.errorsService.exitForm(title, error_message_membership);
        }
      },
      error: (error) => {
        this.errorsService.processError(error, 'soft');
      }
    });
  }

  private validateCorporateStructure(office: Office) {

    const request = new RequestParameters(null);
    request.limit = 100;
    this.officesApiService.getOfficeCorporateStructure(office.office_nrds_id).subscribe({
      next: (corporateStructure) => {
        if (corporateStructure.items.some(o => o.office_nrds_id === this.surveyService.officeId) && !this.surveyService.surveyModel.getVariable('charge_transfer_inside_corp_structure')) {
          this.surveyService.chargeable = false;
        }
      },
      error: (error) => {
        this.errorsService.processError(error);
      }
    });
  }

}
